var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firmware-list" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "primary",
                size: "14",
              },
              on: { click: _vm.handleAssociatedFirmware },
            },
            [_vm._v("关联固件")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
                icon: "el-icon-plus",
              },
              on: { click: _vm.handleAddFirmware },
            },
            [_vm._v("新建固件")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "key", label: "固件Key" } }),
          _c("el-table-column", { attrs: { prop: "name", label: "固件名称" } }),
          _c("el-table-column", { attrs: { prop: "type", label: "固件类型" } }),
          _c("el-table-column", {
            attrs: { prop: "version", label: "固件版本" },
          }),
          _c("el-table-column", {
            attrs: { prop: "number", label: "自定义编号" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "版本说明" },
          }),
          _c("el-table-column", {
            attrs: { prop: "fileName", label: "文件名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "fileName", label: "发布状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.releaseStatus === 0
                      ? _c("span", [_vm._v("未发布")])
                      : _c("span", [_vm._v("已发布")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "450" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleChangeVersion(scope.row)
                          },
                        },
                      },
                      [_vm._v("变更版本")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("发布")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("测试任务")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("升级任务")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          disabled: _vm.rolesCode === "SALE",
                          size: "operate",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("解除绑定")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.current,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("addFirmwareDialog", {
        ref: "addFirmware",
        on: {
          close: _vm.handleClose,
          submit: function ($event) {
            return _vm.submitForm("form")
          },
        },
      }),
      _c("associatedFirmwareDialog", {
        ref: "associatedFirmware",
        attrs: {
          "product-id": _vm.productId,
          "product-name": _vm.form.productName,
        },
        on: { close: _vm.handleClose },
      }),
      _c("changeVersionDialog", {
        ref: "changeVersion",
        on: {
          close: _vm.handleClose,
          submit: function ($event) {
            return _vm.submitForm("form")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }